import React from 'react';
import PropTypes from 'prop-types';
import {ListItemButton, Typography} from '@mui/material';
import {withStyles} from '@mui/styles';

const HIDDEN_PARAMETERS = [8, 9, 10];
const rowHeight = 24;

const styles = {
	actionRow: {
		width: '100%',
		height: `${rowHeight}px`,
		padding: '0 4px',
		transition: 'none !important',
	},
	textRow: {
		paddingLeft: '4px',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		fontFamily: 'monospace !important',
		fontSize: '13px !important',
		lineHeight: `${rowHeight}px !important`,
	},
	col: {
		display: 'flex',
		paddingRight: 4,
		height: '100%',
		flexShrink: '1',
	},
	colWithPadding: {
		paddingLeft: 4,
	},
	colNoPadding: {
		paddingLeft: 0,
	},
	colNoGrow: {
		flexGrow: '0',
	},
	colGrow: {
		flexGrow: '1',
	},
	colNoShrink: {
		flexShrink: '0',
	},
	colShrink: {
		flexShrink: '1',
	}
};

const columnSizes = [['150px', true], ['100px', true], ['100px', true]];

const FixItemRow = ({parameter, classes, theme, textStyle, containerStyle}) => {
	return (
		<ListItemButton disableRipple divider className={classes.actionRow} style={containerStyle}>
			<Typography
				variant="body1"
				className={`${classes.textRow} ${classes.col} ${classes.colNoPadding}`}
				style={{flexBasis: '55px', borderRight: theme.border, ...textStyle}}
			>
				{parameter.tag}
			</Typography>
			{[parameter.name, parameter.value, parameter.valueName].map((item, itemIdx) => {
				let [flexBasis, allowGrow = false, allowShrink = true, withPadding = true] = columnSizes[itemIdx];
				let colStyle = {
					flexBasis,
				};
				let last = itemIdx === 2;
				if (!last) {
					colStyle['borderRight'] = theme.border;
				}
				let colGrowClass = allowGrow ? classes.colGrow : classes.colNoGrow;
				let colShrinkClass = allowShrink ? classes.colShrink : classes.colNoShrink;
				let colPaddingClass = withPadding ? classes.colWithPadding : classes.colNoPadding;
				return (
					<Typography
						key={itemIdx}
						variant="body1"
						className={`${classes.textRow} ${classes.col} ${colPaddingClass} ${colGrowClass} ${colShrinkClass}`}
						style={{...colStyle, ...textStyle}}
					>
						{item}
					</Typography>
				);
			})}
		</ListItemButton>);
};

const FixRow = withStyles(styles, { withTheme: true })(FixItemRow);

FixItemRow.propTypes = {
	parameter: PropTypes.object,
	tagName: PropTypes.string,
	textStyle: PropTypes.object,
	containerStyle: PropTypes.object,

	theme: PropTypes.object,
	classes: PropTypes.object,
};

class FixItemTable extends React.PureComponent {
	constructor(props) {
		super(props);
	}

	filterParameters(parameters) {
		return parameters.filter(parameter => !HIDDEN_PARAMETERS.includes(parameter.tag));
	}

	render() {
		const message = this.props.fixMessage;
		return message.parts?.length
			? <div style={{padding: 4}}>
				<FixRow
					textStyle={{fontWeight: 'bold'}}
					containerStyle={{marginBottom: '8px'}}
					parameter={{tag: 'Tag', name: 'Field Name', value: 'Value', valueName: 'Value Name'}}
				/>
				{this.filterParameters(message.parts).map((parameter, index) =>
					<FixRow key={`${parameter.tag}_${index}`} parameter={parameter}/>)}
			</div>
			: <div></div>;
	}
}


FixItemTable.propTypes = {
	fixMessage: PropTypes.object,
};

export default FixItemTable;